module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Slide 幻灯片")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "250px",
      "width": "500px"
    }
  }, [_c('slide', {
    attrs: {
      "list": _vm.list,
      "duration": 5000
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Html代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div style=\"height: 250px; width: 500px;\">\n  <slide :list=\"list\" :duration=\"5000\"></slide>\n</div>\n")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Script代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("  export default {\n    data() {\n      return {\n        list: [\n          // 传入的数据格式:\n          // imgUrl为图片地址, url为点击图片时的跳转\n          { imgUrl: '/static/imgs/1.jpg', url: '' },\n          { imgUrl: '/static/imgs/2.jpg', url: '' },\n          { imgUrl: '/static/imgs/3.jpg', url: '' },\n          { imgUrl: '/static/imgs/4.jpg', url: '' }\n        ]\n      }\n    }\n  }\n")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Props 列表")]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table striped hovered bordered border"
  }, [_c('thead', [_c('th', [_vm._v("Prop")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Required")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Description")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("list")]), _vm._v(" "), _c('td', [_vm._v("Array")]), _vm._v(" "), _c('td', [_vm._v("True")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("幻灯片的图片列表")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("duration")]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_vm._v("False")]), _vm._v(" "), _c('td', [_vm._v("5000")]), _vm._v(" "), _c('td', [_vm._v("每张图片的停留时间")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07718eee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/slide-demo.vue
// module id = 383
// module chunks = 1